(function () {
  var root = document.querySelector("[data-trade-root]");
  if (!root) return;

  var form = root.querySelector("[data-trade-form]");
  var statusEl = root.querySelector("[data-trade-status]");

  function endpoint() {
    var base = (root.getAttribute("data-api-base") || "").replace(/\/$/, "");
    if (base) return base + "/api/trade/inquiry";
    return "/api/trade/inquiry";
  }

  if (!form) return;

  form.addEventListener("submit", async function (e) {
    e.preventDefault();
    var fd = new FormData(form);
    var payload = {
      name: fd.get("name"),
      email: fd.get("email"),
      company: fd.get("company"),
      phone: fd.get("phone"),
      role: fd.get("role"),
      intent: fd.get("intent"),
      unitsCount: fd.get("unitsCount") ? Number(fd.get("unitsCount")) : 0,
      sitePostcode: fd.get("sitePostcode"),
      timeline: fd.get("timeline"),
      message: fd.get("message"),
      source: fd.get("source") || "sora-trade",
      requestBim: fd.get("requestBim") === "1",
      requestTradePricing: fd.get("requestTradePricing") === "1",
      requestReferral: fd.get("requestReferral") === "1",
    };

    if (statusEl) statusEl.textContent = "Sending enquiry…";

    try {
      var res = await fetch(endpoint(), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      var data = await res.json().catch(function () {
        return {};
      });
      if (!res.ok) throw new Error(data.error || "Enquiry failed");
      if (statusEl) {
        statusEl.textContent =
          "Enquiry " +
          data.id +
          " received. Check your email. Status: " +
          (data.status || "queued") +
          ".";
      }
      form.reset();
    } catch (err) {
      // Zero-email: never open mailto — retry API or show offline status
      if (statusEl) {
        statusEl.textContent =
          "Bridge offline. Enquiry not stored. Retry shortly; we do not use email fallbacks.";
      }
    }
  });
})();
